import { apiBaseUrl } from '../../../api/client.js';

/**
 * Baixa o catálogo em .xlsx (binário) do cliente autorizado.
 * Usa fetch direto porque o `api()` espera JSON; aqui precisamos de um Blob.
 *
 * @param {string} slug
 * @param {string} customerToken
 * @param {string[]} categories Lista de seções; vazio = catálogo todo.
 * @returns {Promise<{ blob: Blob, filename: string }>}
 */
export async function downloadCatalogXlsx(slug, customerToken, categories = []) {
  const params = new URLSearchParams();
  if (Array.isArray(categories) && categories.length > 0) {
    params.set('categories', categories.join(','));
  }
  const qs = params.toString();
  const url = `${apiBaseUrl()}/store/${encodeURIComponent(slug)}/customer/catalog-export${qs ? `?${qs}` : ''}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: { 'X-Customer-Token': customerToken },
    cache: 'no-store',
  });

  if (!res.ok) {
    let msg = `Falha ao baixar o catálogo (HTTP ${res.status}).`;
    try {
      const data = await res.json();
      if (data && data.error) msg = String(data.error);
    } catch {
      /* resposta não-JSON */
    }
    throw new Error(msg);
  }

  const blob = await res.blob();
  let filename = `catalogo-${slug}.xlsx`;
  const cd = res.headers.get('Content-Disposition') || '';
  const match = cd.match(/filename="?([^"]+)"?/i);
  if (match && match[1]) filename = match[1];

  return { blob, filename };
}
